/**
 * Address field formatter (non-changeable)
 */

import {useOrderProcessContext} from '@hconnect/tuc-processes/context/useOrderProcessContext'

import type {FieldFormatter} from './types'

export const useAddressFormatter = (): FieldFormatter => {
  const {processData} = useOrderProcessContext()

  return (context) => {
    const {t} = context
    const {shippingAddress} = processData

    // Format as "Site Name, Street, City, Country"
    const addressParts = [shippingAddress.street, shippingAddress.city].filter(Boolean)

    const formattedAddress = addressParts.length > 0 ? addressParts.join(', ') : null

    const values = formattedAddress
      ? [{text: formattedAddress, isDiscarded: false, isNew: false}]
      : [
          {
            text: t('orderIntake.rmc.orderManagement.notSpecified', 'Not specified'),
            isDiscarded: false,
            isNew: false
          }
        ]

    return {
      values,
      requiresApproval: false,
      hasChanges: false
    }
  }
}
